import { compose } from 'underscore';
import React from 'react';
import { withI18nConsumer } from '@bingads-webui-react/i18n-context';
import { withCurrentExpandedScope } from '@bingads-webui-campaign-react/use-current-scope-entity';
import { StyledNewSummaryPage } from './new-summary-page';

class FeedSummary extends React.PureComponent {
  render() {
    return <StyledNewSummaryPage {...this.props} />;
  }
}

export const StyledFeedSummary = compose(
  withI18nConsumer,
  withCurrentExpandedScope
)(FeedSummary);
